import { useCallback } from 'react';
import { useSocketEvent } from '@connect-x-app/hybrid-data-access';
import { FlightStatus, QueryKeys, TaskAssignedEvent } from '@connect-x-app/shared-domain-models';
import { getFlightRoomStatus } from '@connect-x-app/shared-utils';
import { useQueryClient } from '@tanstack/react-query';

import { useAuthenticationStore, useFlightRoomStore, useSocketStore } from '../../stores';

export const useTaskSocketEvents = () => {
  const { socket } = useSocketStore();
  const { user } = useAuthenticationStore();
  const { flightRooms, updatePartialFlightRoom } = useFlightRoomStore();
  const queryClient = useQueryClient();

  const handleTaskCreated = useCallback(
    () => queryClient.invalidateQueries({ queryKey: [QueryKeys.FLIGHTROOMS, FlightStatus.TASKS] }),
    [queryClient],
  );

  const handleTaskAssigned = useCallback(
    ({ assignedUserId, roomId }: TaskAssignedEvent) => {
      if (assignedUserId === user?.externalId) {
        const room = flightRooms.get(roomId);
        if (room) {
          updatePartialFlightRoom(room.id, { status: getFlightRoomStatus({ ...room, tasks: [] }) });
        }
        queryClient.invalidateQueries({ queryKey: [QueryKeys.FLIGHTROOMS] });
      }
    },
    [flightRooms, queryClient, updatePartialFlightRoom, user?.externalId],
  );

  useSocketEvent(socket, 'task.task-created', handleTaskCreated);
  useSocketEvent(socket, 'task.task-assigned', handleTaskAssigned);
};
